import { render, staticRenderFns } from "./businessonebox-allinbox.vue?vue&type=template&id=afeaa678&"
import script from "./businessonebox-allinbox.vue?vue&type=script&lang=js&"
export * from "./businessonebox-allinbox.vue?vue&type=script&lang=js&"
import style0 from "./businessonebox-allinbox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports